import { createImageProxyUrl } from '../../utils/svtimage';

export const getVariantHeroImages = (item) => {
    const src = createImageProxyUrl(item.images.wide.id, item.images.wide.changed, 'wide', 800);

    const altText = item.images.wide.description;

    const srcSets = [
        `${createImageProxyUrl(item.images.wide.id, item.images.wide.changed, 'wide', 600)} 600w`,
        `${createImageProxyUrl(item.images.wide.id, item.images.wide.changed, 'wide', 800)} 800w`,
        `${createImageProxyUrl(item.images.wide.id, item.images.wide.changed, 'wide', 1024)} 1024w`,
        `${createImageProxyUrl(item.images.wide.id, item.images.wide.changed, 'wide', 1480)} 1480w`,
        `${createImageProxyUrl(item.images.wide.id, item.images.wide.changed, 'wide', 1920)} 1920w`,
    ];

    const sources = [];
    const sizes = '(max-width: 1200px) 100vw, 70vw';

    return {
        src,
        srcSets,
        sources,
        sizes,
        altText,
    };
};
